import React, { useEffect } from 'react';
import styles from './AttendeePhotosModal.module.css';

export default function AttendeePhotosModal({ images, onClose, attendeeName }) {
    useEffect(() => {
        function handleClickOutside(e) {
            if (e.target.classList.contains(styles.overlay)) {
                onClose();
            }
        }
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, [onClose]);

    return (
        <div className={styles.overlay}>
            <div className={styles.modal}>
                <h3>{attendeeName} Photos</h3>
                <div className={styles.imagesGrid}>
                    {images.map(img => (
                        <img key={img.id} src={img.imageUrl.startsWith('http') ? img.imageUrl : `https://arnd-development.s3.us-west-1.amazonaws.com/${img.imageUrl}`} alt="Attendee" className={styles.photo} />
                    ))}
                </div>
                <button className={styles.closeBtn} onClick={onClose}>Close</button>
            </div>
        </div>
    );
}
